import gql from 'graphql-tag';

export const PAYMENT_METHOD_FRAGMENT = gql`
  fragment paymentMethodData on PaymentMethod {
    id
    expirationDate
    source
    type
    description
  }
`;

export const GET_ACCOUNT_PAYMENT_METHODS = gql`
  query GetAccountPaymentMethods($accountId: Int!) {
    account(id: $accountId) {
      id
      paymentMethods {
        ...paymentMethodData
        mostRecentPaymentTransaction {
          id
          status
        }
      }
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;

const errorTransaction = {
  id: 1,
  status: 'declined',
  paymentMethodId: 3,
};

const nonErrorTransaction = {
  id: 1,
  status: 'accepted',
};

export const achPaymentMethod = {
  id: 1,
  expirationDate: '2025-01',
  source: 'Bank of Fakerson',
  type: 'ach',
  __typename: 'PaymentMethod',
  mostRecentPaymentTransaction: nonErrorTransaction,
  description: 'Bank of Fakerson 4444',
};

export const creditCardPaymentMethod = {
  id: 2,
  expirationDate: '2027-02',
  source: 'Visa',
  type: 'credit_card',
  __typename: 'PaymentMethod',
  mostRecentPaymentTransaction: nonErrorTransaction,
  description: 'Visa 5555',
};

export const errorPaymentMethod = {
  id: 3,
  expirationDate: '2027-02',
  source: 'Visa',
  type: 'credit_card',
  __typename: 'PaymentMethod',
  mostRecentPaymentTransaction: errorTransaction,
  description: 'Visa 5555',
};

export const cashAppPaymentMethod = {
  id: 2,
  expirationDate: null,
  source: null,
  type: 'cashapp',
  __typename: 'PaymentMethod',
  description: 'cashapp',
};

export const errorStatement = {
  id: 1,
  mostRecentPaymentTransaction: errorTransaction,
  total: 10456,
};

export const nonErrorStatement = {
  id: 2,
  mostRecentPaymentTransaction: nonErrorTransaction,
  total: 10456,
};

export const GetAccountPaymentMethodsMock = {
  account: {
    id: 2,
    paymentMethods: [achPaymentMethod, creditCardPaymentMethod],
  },
};

export const GetErrorAccountPaymentMethodsMock = {
  account: {
    id: 2,
    paymentMethods: [errorPaymentMethod, creditCardPaymentMethod],
  },
};

// Note this must match the limit passed to search plans;
export const ACTIVE_WHALE_PLAN_LIMIT = 10;
export const GET_PLANS_FOR_ADD_MODAL = gql`
  query GetPlansForAddModal($accountId: Int!) {
    search {
      plans(
        page: 0
        limit: 10
        sort: created_at
        order: ASC
        filters: { accountId: $accountId, statuses: ["active"] }
      ) {
        count
        plans {
          id
          displayName
          paymentMethodId
        }
      }
    }
  }
`;

// Note this must match the limit passed to search plans;
export const PLAN_METHODS_PAGINATION_LIMIT = 5;
export const GET_PAYMENT_SETTINGS_INFO = gql`
  query GetPaymentSettingsInfo($accountId: Int!, $page: Int!) {
    account(id: $accountId) {
      paymentMethods {
        id
      }
    }
    search {
      plans(
        page: $page
        limit: 5
        sort: created_at
        order: ASC
        filters: { accountId: $accountId, statuses: ["active"] }
      ) {
        count
        plans {
          id
          displayName
          utilityAccounts {
            id
            targetBillExperience
            funnelBillExperience
            activeBillingSettings {
              billExperience
            }
          }
          mostRecentStatement {
            id
            mostRecentPaymentTransaction {
              id
              status
              paymentMethodId
            }
            total
          }
          paymentMethod {
            ...paymentMethodData
          }
        }
      }
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;

export const SET_PAYMENT_METHOD_ON_PLANS = gql`
  mutation SetPaymentMethodOnPlans(
    $accountId: Int!
    $input: SetPaymentMethodOnPlansInput!
    $skipDisplayName: Boolean!
  ) {
    setPaymentMethodOnPlans(accountId: $accountId, input: $input) {
      updatedPlans {
        id
        displayName @skip(if: $skipDisplayName)
        paymentMethodId
        paymentMethod {
          id
        }
      }
    }
  }
`;

export const setPaymentMethodOnPlansMock = {
  setPaymentMethodOnPlans: {
    updatedPlans: [
      {
        id: 2,
        displayName: 'My plan',
        paymentMethodId: 3,
        paymentMethod: {
          id: 3,
        },
      },
    ],
  },
};

const mockPlans = ({ count = 1 } = {}) =>
  [...Array(count)].map((_, index) => {
    const paymentMethod =
      index % 2 === 0 ? achPaymentMethod : creditCardPaymentMethod;

    return {
      accountId: 2,
      status: 'active',
      displayName: `Plan ${index + 1}`,
      id: index + 1,
      paymentMethodId: paymentMethod.id,
      paymentMethod,
      mostRecentStatement: null,
      utilityAccounts: [
        {
          id: index + 20,
          funnelBillExperience: 'arcadia_billed',
          activeBillingSettings: [{ billExperience: null }],
        },
      ],
    };
  });

export const singleActivePlanMock = {
  account: {
    id: 2,
    paymentMethods: [achPaymentMethod, creditCardPaymentMethod],
  },
  search: {
    plans: {
      plans: mockPlans(),
      count: 1,
    },
  },
};

export const multipleActivePlansMock = {
  account: {
    id: 2,
    paymentMethods: [achPaymentMethod, creditCardPaymentMethod],
  },
  search: {
    plans: {
      plans: mockPlans({ count: 6 }),
      count: 6,
    },
  },
};

export const GetAddModalPlansMock = {
  search: {
    plans: {
      count: 2,
      plans: mockPlans({
        count: 2,
      }),
    },
  },
};
